<mat-dialog-content>{{description}}</mat-dialog-content>
<mat-dialog-actions>
    <div class="col-xs-12 text-center">
        <button class="btn btn-primary" id="omsFail" (click)="close()">Close</button>
    </div>
</mat-dialog-actions>